import { Icon } from 'antd';
/* 
  Icons from https://material.io/icons/
*/
import React from "react";
export var ZoomInIcon = function ZoomInIcon() {
  return  React.createElement("svg", {
    fill: "#ffffff",
    height: "32",
    viewBox: "0 -3 24 24",
    width: "32",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
  }));
};
export var ZoomOutIcon = function ZoomOutIcon() {
  return React.createElement("svg", {
    fill: "#ffffff",
    height: "32",
    viewBox: "0 -3 24 24",
    width: "32",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
  }));
};
export var DownloadIcon = function DownloadIcon() {
  return  <Icon type="download" style={{fontSize:32}}/>  /*React.createElement("svg", {
    fill: "#ffffff",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
  }), React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));*/
};
export var CloseIcon = function CloseIcon() {
  return React.createElement("svg", {
    fill: "#ffffff",
    height: "32",
    viewBox: "0 -3 24 24",
    width: "32",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};
export var SpinnerIcon = function SpinnerIcon() {
  return React.createElement("svg", {
    fill: "#ffffff",
    height: "48",
    viewBox: "0 0 24 24",
    width: "48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"
  }), React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }));
};
export var RotateIcon = function RotateIcon() {
  return React.createElement("svg", {
    fill: "#ffffff",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0zm0 0h24v24H0V0z"
  }), React.createElement("path", {
    d: "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8c0-1.11-.9-2-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2H8z"
  }));
};
/// SHVG
export var NextIcon = function NextIcon() {
  return  <Icon type="arrow-right" style={{fontSize:28}}/> 
};
export var PrevIcon = function PrevIcon() {
  return  <Icon type="arrow-left" style={{fontSize:28}}/> 
};
/// ----
